export var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["UNKNOWN_SUBMISSION_STATUS"] = "UNKNOWN_SUBMISSION_STATUS";
    /** A submission is created, but has not yet been recorded in the Wix Forms collection. */
    SubmissionStatus["PENDING"] = "PENDING";
    /** A submission is recorded in the Wix Forms collection. */
    SubmissionStatus["CONFIRMED"] = "CONFIRMED";
    /** A form submission requiring payment is created. */
    SubmissionStatus["PAYMENT_WAITING"] = "PAYMENT_WAITING";
    /** An order of a form submission is canceled. */
    SubmissionStatus["PAYMENT_CANCELED"] = "PAYMENT_CANCELED";
})(SubmissionStatus || (SubmissionStatus = {}));
export var OptInLevel;
(function (OptInLevel) {
    /** Single confirmation. */
    OptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    /** Double confirmation. */
    OptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(OptInLevel || (OptInLevel = {}));
export var StringTypeFormatEnumFormat;
(function (StringTypeFormatEnumFormat) {
    StringTypeFormatEnumFormat["UNDEFINED"] = "UNDEFINED";
    StringTypeFormatEnumFormat["DATE"] = "DATE";
    StringTypeFormatEnumFormat["TIME"] = "TIME";
    StringTypeFormatEnumFormat["DATE_TIME"] = "DATE_TIME";
    StringTypeFormatEnumFormat["EMAIL"] = "EMAIL";
    StringTypeFormatEnumFormat["URL"] = "URL";
    StringTypeFormatEnumFormat["UUID"] = "UUID";
    StringTypeFormatEnumFormat["PHONE"] = "PHONE";
    StringTypeFormatEnumFormat["URI"] = "URI";
    StringTypeFormatEnumFormat["HOSTNAME"] = "HOSTNAME";
    StringTypeFormatEnumFormat["COLOR_HEX"] = "COLOR_HEX";
    StringTypeFormatEnumFormat["CURRENCY"] = "CURRENCY";
    StringTypeFormatEnumFormat["LANGUAGE"] = "LANGUAGE";
    StringTypeFormatEnumFormat["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(StringTypeFormatEnumFormat || (StringTypeFormatEnumFormat = {}));
export var ValidationFormat;
(function (ValidationFormat) {
    ValidationFormat["UNDEFINED"] = "UNDEFINED";
    /** File upload validation. */
    ValidationFormat["WIX_FILE"] = "WIX_FILE";
    /** Payment validation. */
    ValidationFormat["PAYMENT"] = "PAYMENT";
    /** Multiline address. */
    ValidationFormat["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
    /** Scheduling validation. */
    ValidationFormat["SCHEDULING"] = "SCHEDULING";
    /** Object array validation. */
    ValidationFormat["OBJECT_ARRAY"] = "OBJECT_ARRAY";
})(ValidationFormat || (ValidationFormat = {}));
export var ProductType;
(function (ProductType) {
    /** Unknown product type. */
    ProductType["UNKNOWN_PRODUCT_TYPE"] = "UNKNOWN_PRODUCT_TYPE";
    /** Physical product that can be shipped. */
    ProductType["SHIPPABLE"] = "SHIPPABLE";
    /** Digital product. */
    ProductType["DIGITAL"] = "DIGITAL";
})(ProductType || (ProductType = {}));
export var PriceType;
(function (PriceType) {
    /** Unknown price type. */
    PriceType["UNKNOWN_PRICE_TYPE"] = "UNKNOWN_PRICE_TYPE";
    /** Product has a single, unchanging price. */
    PriceType["FIXED_PRICE"] = "FIXED_PRICE";
    /** Product price can vary within a specified range. */
    PriceType["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
})(PriceType || (PriceType = {}));
export var FieldType;
(function (FieldType) {
    /** Unknown field type. */
    FieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    /** Input field that collects data from users. */
    FieldType["INPUT"] = "INPUT";
    /** Display field that shows information without collecting input. */
    FieldType["DISPLAY"] = "DISPLAY";
})(FieldType || (FieldType = {}));
export var FormatEnumFormat;
(function (FormatEnumFormat) {
    /** Unknown format. */
    FormatEnumFormat["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    /** Date format. */
    FormatEnumFormat["DATE"] = "DATE";
    /** Time format. */
    FormatEnumFormat["TIME"] = "TIME";
    /** Date and time format. */
    FormatEnumFormat["DATE_TIME"] = "DATE_TIME";
    /** Email format. */
    FormatEnumFormat["EMAIL"] = "EMAIL";
    /** URL format. */
    FormatEnumFormat["URL"] = "URL";
    /** UUID format. */
    FormatEnumFormat["UUID"] = "UUID";
    /** Phone number format. */
    FormatEnumFormat["PHONE"] = "PHONE";
    /** URI format. */
    FormatEnumFormat["URI"] = "URI";
    /** Hostname format. */
    FormatEnumFormat["HOSTNAME"] = "HOSTNAME";
    /** Hexadecimal color code format. */
    FormatEnumFormat["COLOR_HEX"] = "COLOR_HEX";
    /** Currency format. */
    FormatEnumFormat["CURRENCY"] = "CURRENCY";
    /** Language code format. */
    FormatEnumFormat["LANGUAGE"] = "LANGUAGE";
    /** Date with optional time format. */
    FormatEnumFormat["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(FormatEnumFormat || (FormatEnumFormat = {}));
export var StringComponentType;
(function (StringComponentType) {
    /** Unknown component type. */
    StringComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Text input component. */
    StringComponentType["TEXT_INPUT"] = "TEXT_INPUT";
    /** Radio group component. */
    StringComponentType["RADIO_GROUP"] = "RADIO_GROUP";
    /** Dropdown component. */
    StringComponentType["DROPDOWN"] = "DROPDOWN";
    /** Date and time component. */
    StringComponentType["DATE_TIME"] = "DATE_TIME";
    /** Phone number component. */
    StringComponentType["PHONE_INPUT"] = "PHONE_INPUT";
    /** Date selection component. */
    StringComponentType["DATE_INPUT"] = "DATE_INPUT";
    /** Time selection component. */
    StringComponentType["TIME_INPUT"] = "TIME_INPUT";
    /** Calendar-style date picker component. */
    StringComponentType["DATE_PICKER"] = "DATE_PICKER";
    /** Dropdown component for selecting available services. */
    StringComponentType["SERVICES_DROPDOWN"] = "SERVICES_DROPDOWN";
})(StringComponentType || (StringComponentType = {}));
export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    /** @deprecated */
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
    NodeType["CAPTION"] = "CAPTION";
    NodeType["LAYOUT"] = "LAYOUT";
    NodeType["LAYOUT_CELL"] = "LAYOUT_CELL";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var ButtonDataType;
(function (ButtonDataType) {
    /** Regular link button */
    ButtonDataType["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    ButtonDataType["ACTION"] = "ACTION";
})(ButtonDataType || (ButtonDataType = {}));
export var LinkTarget;
(function (LinkTarget) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    LinkTarget["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    LinkTarget["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    LinkTarget["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    LinkTarget["TOP"] = "TOP";
})(LinkTarget || (LinkTarget = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var Width;
(function (Width) {
    /** Large line */
    Width["LARGE"] = "LARGE";
    /** Medium line */
    Width["MEDIUM"] = "MEDIUM";
    /** Small line */
    Width["SMALL"] = "SMALL";
})(Width || (Width = {}));
export var DividerDataAlignment;
(function (DividerDataAlignment) {
    /** Center alignment */
    DividerDataAlignment["CENTER"] = "CENTER";
    /** Left alignment */
    DividerDataAlignment["LEFT"] = "LEFT";
    /** Right alignment */
    DividerDataAlignment["RIGHT"] = "RIGHT";
})(DividerDataAlignment || (DividerDataAlignment = {}));
export var ViewMode;
(function (ViewMode) {
    /** No PDF view */
    ViewMode["NONE"] = "NONE";
    /** Full PDF view */
    ViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    ViewMode["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var GIFType;
(function (GIFType) {
    GIFType["NORMAL"] = "NORMAL";
    GIFType["STICKER"] = "STICKER";
})(GIFType || (GIFType = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
    Source["AI"] = "AI";
})(Source || (Source = {}));
export var Position;
(function (Position) {
    /** Thumbnail positioned at the start (left in LTR layouts, right in RTL layouts) */
    Position["START"] = "START";
    /** Thumbnail positioned at the end (right in LTR layouts, left in RTL layouts) */
    Position["END"] = "END";
    /** Thumbnail positioned at the top */
    Position["TOP"] = "TOP";
    /** Thumbnail hidden and not displayed */
    Position["HIDDEN"] = "HIDDEN";
})(Position || (Position = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
    DecorationType["STRIKETHROUGH"] = "STRIKETHROUGH";
    DecorationType["SUPERSCRIPT"] = "SUPERSCRIPT";
    DecorationType["SUBSCRIPT"] = "SUBSCRIPT";
    DecorationType["FONT_FAMILY"] = "FONT_FAMILY";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var ImageStylesPosition;
(function (ImageStylesPosition) {
    /** Image positioned at the start (left in LTR layouts, right in RTL layouts) */
    ImageStylesPosition["START"] = "START";
    /** Image positioned at the end (right in LTR layouts, left in RTL layouts) */
    ImageStylesPosition["END"] = "END";
    /** Image positioned at the top */
    ImageStylesPosition["TOP"] = "TOP";
})(ImageStylesPosition || (ImageStylesPosition = {}));
export var AspectRatio;
(function (AspectRatio) {
    /** 1:1 aspect ratio */
    AspectRatio["SQUARE"] = "SQUARE";
    /** 16:9 aspect ratio */
    AspectRatio["RECTANGLE"] = "RECTANGLE";
})(AspectRatio || (AspectRatio = {}));
export var Resizing;
(function (Resizing) {
    /** Fill the container, may crop the image */
    Resizing["FILL"] = "FILL";
    /** Fit the image within the container */
    Resizing["FIT"] = "FIT";
})(Resizing || (Resizing = {}));
export var Placement;
(function (Placement) {
    /** Ribbon placed on the image */
    Placement["IMAGE"] = "IMAGE";
    /** Ribbon placed on the product information */
    Placement["PRODUCT_INFO"] = "PRODUCT_INFO";
})(Placement || (Placement = {}));
export var CardStylesType;
(function (CardStylesType) {
    /** Card with visible border and background */
    CardStylesType["CONTAINED"] = "CONTAINED";
    /** Card without visible border */
    CardStylesType["FRAMELESS"] = "FRAMELESS";
})(CardStylesType || (CardStylesType = {}));
export var CardStylesAlignment;
(function (CardStylesAlignment) {
    /** Content aligned to start (left in LTR layouts, right in RTL layouts) */
    CardStylesAlignment["START"] = "START";
    /** Content centered */
    CardStylesAlignment["CENTER"] = "CENTER";
    /** Content aligned to end (right in LTR layouts, left in RTL layouts) */
    CardStylesAlignment["END"] = "END";
})(CardStylesAlignment || (CardStylesAlignment = {}));
export var CardStylesLayout;
(function (CardStylesLayout) {
    /** Elements stacked vertically */
    CardStylesLayout["STACKED"] = "STACKED";
    /** Elements arranged horizontally */
    CardStylesLayout["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
})(CardStylesLayout || (CardStylesLayout = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var Scaling;
(function (Scaling) {
    /** Auto image scaling */
    Scaling["AUTO"] = "AUTO";
    /** Contain image scaling */
    Scaling["CONTAIN"] = "CONTAIN";
    /** Cover image scaling */
    Scaling["COVER"] = "COVER";
})(Scaling || (Scaling = {}));
export var LayoutDataImagePosition;
(function (LayoutDataImagePosition) {
    /** Image positioned at the center */
    LayoutDataImagePosition["CENTER"] = "CENTER";
    /** Image positioned on the left */
    LayoutDataImagePosition["CENTER_LEFT"] = "CENTER_LEFT";
    /** Image positioned on the right */
    LayoutDataImagePosition["CENTER_RIGHT"] = "CENTER_RIGHT";
    /** Image positioned at the center top */
    LayoutDataImagePosition["TOP"] = "TOP";
    /** Image positioned at the top left */
    LayoutDataImagePosition["TOP_LEFT"] = "TOP_LEFT";
    /** Image positioned at the top right */
    LayoutDataImagePosition["TOP_RIGHT"] = "TOP_RIGHT";
    /** Image positioned at the center bottom */
    LayoutDataImagePosition["BOTTOM"] = "BOTTOM";
    /** Image positioned at the bottom left */
    LayoutDataImagePosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    /** Image positioned at the bottom right */
    LayoutDataImagePosition["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(LayoutDataImagePosition || (LayoutDataImagePosition = {}));
export var VerticalAlignmentAlignment;
(function (VerticalAlignmentAlignment) {
    /** Top alignment */
    VerticalAlignmentAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignmentAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignmentAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignmentAlignment || (VerticalAlignmentAlignment = {}));
export var ResponsivenessBehaviour;
(function (ResponsivenessBehaviour) {
    /** Stacking of columns */
    ResponsivenessBehaviour["STACK"] = "STACK";
    /** Wrapping of columns */
    ResponsivenessBehaviour["WRAP"] = "WRAP";
})(ResponsivenessBehaviour || (ResponsivenessBehaviour = {}));
export var ImagePosition;
(function (ImagePosition) {
    /** Undefined position. */
    ImagePosition["UNKNOWN_IMAGE_POSITION"] = "UNKNOWN_IMAGE_POSITION";
    /** Above the field's label. */
    ImagePosition["ABOVE"] = "ABOVE";
    /** Below the field's label. */
    ImagePosition["BELOW"] = "BELOW";
})(ImagePosition || (ImagePosition = {}));
export var Alignment;
(function (Alignment) {
    /** Undefined alignment. */
    Alignment["UNKNOWN_ALIGNMENT"] = "UNKNOWN_ALIGNMENT";
    /** Align left. */
    Alignment["LEFT"] = "LEFT";
    /** Align center. */
    Alignment["CENTER"] = "CENTER";
    /** Align right. */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var ImageFit;
(function (ImageFit) {
    ImageFit["UNKNOWN_IMAGE_FIT"] = "UNKNOWN_IMAGE_FIT";
    /** Scale the image to maintain its aspect ratio while filling the element's entire content box. Portions of the image may be clipped if the aspect ratios don't match. */
    ImageFit["COVER"] = "COVER";
    /** Resize the image to fill the element's content box. The image's original sspect ratio may not be preserved. */
    ImageFit["CONTAIN"] = "CONTAIN";
})(ImageFit || (ImageFit = {}));
export var NumberOfColumns;
(function (NumberOfColumns) {
    /** Undefined number of columns. */
    NumberOfColumns["UNKNOWN_NUMBER_OF_COLUMNS"] = "UNKNOWN_NUMBER_OF_COLUMNS";
    /** Zero columns. */
    NumberOfColumns["ZERO"] = "ZERO";
    /** One column. */
    NumberOfColumns["ONE"] = "ONE";
    /** Two columns. */
    NumberOfColumns["TWO"] = "TWO";
    /** Three columns. */
    NumberOfColumns["THREE"] = "THREE";
})(NumberOfColumns || (NumberOfColumns = {}));
export var FirstDayOfWeek;
(function (FirstDayOfWeek) {
    /** First day of the week is Monday. */
    FirstDayOfWeek["MONDAY"] = "MONDAY";
    /** First day of the week is Sunday. */
    FirstDayOfWeek["SUNDAY"] = "SUNDAY";
})(FirstDayOfWeek || (FirstDayOfWeek = {}));
export var NumberComponentType;
(function (NumberComponentType) {
    /** Unknown component type. */
    NumberComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Numeric input component. */
    NumberComponentType["NUMBER_INPUT"] = "NUMBER_INPUT";
    /** Rating input component. */
    NumberComponentType["RATING_INPUT"] = "RATING_INPUT";
})(NumberComponentType || (NumberComponentType = {}));
export var BooleanComponentType;
(function (BooleanComponentType) {
    /** Unknown component type. */
    BooleanComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Checkbox component. */
    BooleanComponentType["CHECKBOX"] = "CHECKBOX";
})(BooleanComponentType || (BooleanComponentType = {}));
export var ItemType;
(function (ItemType) {
    /** Unknown item type. */
    ItemType["UNKNOWN_ITEM_TYPE"] = "UNKNOWN_ITEM_TYPE";
    /** Array can contain string values. */
    ItemType["STRING"] = "STRING";
    /** Array can contain numeric values. */
    ItemType["NUMBER"] = "NUMBER";
    /** Array can contain boolean values. */
    ItemType["BOOLEAN"] = "BOOLEAN";
    /** Array can contain object values. */
    ItemType["OBJECT"] = "OBJECT";
})(ItemType || (ItemType = {}));
export var PropertiesTypeEnum;
(function (PropertiesTypeEnum) {
    /** Unknown property type. */
    PropertiesTypeEnum["UNKNOWN_PROPERTY_TYPE"] = "UNKNOWN_PROPERTY_TYPE";
    /** Property must contain a string value. */
    PropertiesTypeEnum["STRING"] = "STRING";
    /** Property must contain a numeric value. */
    PropertiesTypeEnum["NUMBER"] = "NUMBER";
    /** Property must contain a boolean value. */
    PropertiesTypeEnum["BOOLEAN"] = "BOOLEAN";
    /** Property must contain an array. */
    PropertiesTypeEnum["ARRAY"] = "ARRAY";
})(PropertiesTypeEnum || (PropertiesTypeEnum = {}));
export var ArrayComponentType;
(function (ArrayComponentType) {
    /** Unknown component type. */
    ArrayComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Checkbox group component. */
    ArrayComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    /** Tags component. */
    ArrayComponentType["TAGS"] = "TAGS";
    ArrayComponentType["SERVICES_CHECKBOX_GROUP"] = "SERVICES_CHECKBOX_GROUP";
})(ArrayComponentType || (ArrayComponentType = {}));
export var WixFileComponentType;
(function (WixFileComponentType) {
    /** Unknown component type. */
    WixFileComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** File upload component. */
    WixFileComponentType["FILE_UPLOAD"] = "FILE_UPLOAD";
    /** Signature component. */
    WixFileComponentType["SIGNATURE"] = "SIGNATURE";
})(WixFileComponentType || (WixFileComponentType = {}));
export var UploadFileFormat;
(function (UploadFileFormat) {
    /** Undefined upload file format. */
    UploadFileFormat["UNKNOWN_UPLOAD_FILE_FORMAT"] = "UNKNOWN_UPLOAD_FILE_FORMAT";
    /** Video files. */
    UploadFileFormat["VIDEO"] = "VIDEO";
    /** Image files. */
    UploadFileFormat["IMAGE"] = "IMAGE";
    /** Audio files. */
    UploadFileFormat["AUDIO"] = "AUDIO";
    /** Document files. */
    UploadFileFormat["DOCUMENT"] = "DOCUMENT";
    /** Archive files. */
    UploadFileFormat["ARCHIVE"] = "ARCHIVE";
})(UploadFileFormat || (UploadFileFormat = {}));
export var PaymentComponentType;
(function (PaymentComponentType) {
    /** Unknown component type. */
    PaymentComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Checkbox group component. */
    PaymentComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    /** Donation input component. */
    PaymentComponentType["DONATION_INPUT"] = "DONATION_INPUT";
    /** Payment input component. */
    PaymentComponentType["PAYMENT_INPUT"] = "PAYMENT_INPUT";
    /** Fixed payment component. */
    PaymentComponentType["FIXED_PAYMENT"] = "FIXED_PAYMENT";
})(PaymentComponentType || (PaymentComponentType = {}));
export var ComponentType;
(function (ComponentType) {
    /** Unknown component type. */
    ComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Multiline address component. */
    ComponentType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(ComponentType || (ComponentType = {}));
export var Type;
(function (Type) {
    /** Unknown default country configuration type. */
    Type["UNKNOWN_DEFAULT_COUNTRY"] = "UNKNOWN_DEFAULT_COUNTRY";
    /** Country is determined by the submitter's IP address. */
    Type["BY_IP"] = "BY_IP";
    /** Pre-selected default country. */
    Type["COUNTRY"] = "COUNTRY";
})(Type || (Type = {}));
export var ObjectArrayComponentType;
(function (ObjectArrayComponentType) {
    /** Unknown component type. */
    ObjectArrayComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Repeater component. */
    ObjectArrayComponentType["REPEATER"] = "REPEATER";
})(ObjectArrayComponentType || (ObjectArrayComponentType = {}));
export var SchedulingComponentType;
(function (SchedulingComponentType) {
    /** Unknown component type. */
    SchedulingComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Appointment component. */
    SchedulingComponentType["APPOINTMENT"] = "APPOINTMENT";
})(SchedulingComponentType || (SchedulingComponentType = {}));
export var Format;
(function (Format) {
    Format["UNKNOWN_FORMAT_TYPE"] = "UNKNOWN_FORMAT_TYPE";
    /** Face-to-face meeting at a physical location. */
    Format["IN_PERSON"] = "IN_PERSON";
    /** Online meeting via video conference. */
    Format["VIDEO_CONFERENCE"] = "VIDEO_CONFERENCE";
    /** Appointment conducted over the phone. */
    Format["PHONE"] = "PHONE";
})(Format || (Format = {}));
export var InputType;
(function (InputType) {
    /** Unknown input type. */
    InputType["UNKNOWN_INPUT_TYPE"] = "UNKNOWN_INPUT_TYPE";
    /** String input. */
    InputType["STRING"] = "STRING";
    /** Numeric input. */
    InputType["NUMBER"] = "NUMBER";
    /** Boolean input. */
    InputType["BOOLEAN"] = "BOOLEAN";
    /** Array input. */
    InputType["ARRAY"] = "ARRAY";
    /** Object input. */
    InputType["OBJECT"] = "OBJECT";
    /** File upload input. */
    InputType["WIX_FILE"] = "WIX_FILE";
    /** Payment input. */
    InputType["PAYMENT"] = "PAYMENT";
    /** Scheduling input. */
    InputType["SCHEDULING"] = "SCHEDULING";
    /** Address input. */
    InputType["ADDRESS"] = "ADDRESS";
    /** Multiline address input. */
    InputType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
    /** Array of objects input. */
    InputType["OBJECT_ARRAY"] = "OBJECT_ARRAY";
})(InputType || (InputType = {}));
export var EmailInfoTag;
(function (EmailInfoTag) {
    /** Untagged email address. */
    EmailInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Primary email address for the contact. */
    EmailInfoTag["MAIN"] = "MAIN";
})(EmailInfoTag || (EmailInfoTag = {}));
export var PhoneInfoTag;
(function (PhoneInfoTag) {
    /** Untagged phone number. */
    PhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Primary phone number for the contact. */
    PhoneInfoTag["MAIN"] = "MAIN";
})(PhoneInfoTag || (PhoneInfoTag = {}));
export var Tag;
(function (Tag) {
    /** Untagged address. */
    Tag["UNTAGGED"] = "UNTAGGED";
    /** Home address. */
    Tag["HOME"] = "HOME";
})(Tag || (Tag = {}));
export var ConfirmationLevel;
(function (ConfirmationLevel) {
    /** Unknown confirmation level. */
    ConfirmationLevel["UNKNOWN_CONFIRMATION_LEVEL"] = "UNKNOWN_CONFIRMATION_LEVEL";
    /** Single confirmation level. */
    ConfirmationLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    /** Double confirmation level. */
    ConfirmationLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(ConfirmationLevel || (ConfirmationLevel = {}));
export var ContactField;
(function (ContactField) {
    ContactField["UNKNOWN_CONTACT_FIELD"] = "UNKNOWN_CONTACT_FIELD";
    /** Contact's first name. */
    ContactField["FIRST_NAME"] = "FIRST_NAME";
    /** Contact's last name. */
    ContactField["LAST_NAME"] = "LAST_NAME";
    /** Contact's company or organization. */
    ContactField["COMPANY"] = "COMPANY";
    /** Contact's job title or position. */
    ContactField["POSITION"] = "POSITION";
    /** Contact's email address. */
    ContactField["EMAIL"] = "EMAIL";
    /** Contact's phone number. */
    ContactField["PHONE"] = "PHONE";
    /** Contact's physical address. */
    ContactField["ADDRESS"] = "ADDRESS";
    /** Contact's birth date. */
    ContactField["BIRTHDATE"] = "BIRTHDATE";
    /** Custom contact field defined by the site owner. */
    ContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    /** Contact's subscription preferences. */
    ContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    /** Contact's VAT identification number. */
    ContactField["VAT_ID"] = "VAT_ID";
})(ContactField || (ContactField = {}));
export var DisplayFieldDisplayFieldType;
(function (DisplayFieldDisplayFieldType) {
    /** Unknown field type. */
    DisplayFieldDisplayFieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    /** Rich content display field. */
    DisplayFieldDisplayFieldType["RICH_CONTENT"] = "RICH_CONTENT";
    /** Page navigation display field. */
    DisplayFieldDisplayFieldType["PAGE_NAVIGATION"] = "PAGE_NAVIGATION";
    /** Login bar display field. */
    DisplayFieldDisplayFieldType["LOGIN_BAR"] = "LOGIN_BAR";
})(DisplayFieldDisplayFieldType || (DisplayFieldDisplayFieldType = {}));
export var OverrideEntityType;
(function (OverrideEntityType) {
    /** Unknown override entity type. */
    OverrideEntityType["UNKNOWN"] = "UNKNOWN";
    /** Override applies to a form field. */
    OverrideEntityType["FIELD"] = "FIELD";
    /** Override applies to the form itself. */
    OverrideEntityType["FORM"] = "FORM";
    /** Override applies to a field within a nested form. */
    OverrideEntityType["NESTED_FORM_FIELD"] = "NESTED_FORM_FIELD";
})(OverrideEntityType || (OverrideEntityType = {}));
export var Kind;
(function (Kind) {
    /** Return forms specific to tenant, excluding template based forms. */
    Kind["REGULAR"] = "REGULAR";
    /** Return forms based on common templates, with applied user overrides if they exist. */
    Kind["EXTENSION"] = "EXTENSION";
})(Kind || (Kind = {}));
export var FormFieldContactInfoEmailInfoTag;
(function (FormFieldContactInfoEmailInfoTag) {
    /** Email without a specific tag. */
    FormFieldContactInfoEmailInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Primary email address for the contact. */
    FormFieldContactInfoEmailInfoTag["MAIN"] = "MAIN";
})(FormFieldContactInfoEmailInfoTag || (FormFieldContactInfoEmailInfoTag = {}));
export var FormFieldContactInfoPhoneInfoTag;
(function (FormFieldContactInfoPhoneInfoTag) {
    /** Phone number without a specific tag. */
    FormFieldContactInfoPhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Primary phone number for the contact. */
    FormFieldContactInfoPhoneInfoTag["MAIN"] = "MAIN";
})(FormFieldContactInfoPhoneInfoTag || (FormFieldContactInfoPhoneInfoTag = {}));
export var AddressInfoTag;
(function (AddressInfoTag) {
    /** Address without a specific tag. */
    AddressInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Home address for the contact. */
    AddressInfoTag["HOME"] = "HOME";
})(AddressInfoTag || (AddressInfoTag = {}));
export var SubscriptionInfoOptInLevel;
(function (SubscriptionInfoOptInLevel) {
    /** Unknown opt-in level. */
    SubscriptionInfoOptInLevel["UNKNOWN"] = "UNKNOWN";
    /** Single confirmation opt-in. The contact is subscribed immediately. */
    SubscriptionInfoOptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    /** Double confirmation opt-in. The contact must confirm their subscription via email. */
    SubscriptionInfoOptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(SubscriptionInfoOptInLevel || (SubscriptionInfoOptInLevel = {}));
export var FormFieldContactInfoContactField;
(function (FormFieldContactInfoContactField) {
    /** Unknown contact field. */
    FormFieldContactInfoContactField["UNDEFINED"] = "UNDEFINED";
    /** First name. */
    FormFieldContactInfoContactField["FIRST_NAME"] = "FIRST_NAME";
    /** CLast name. */
    FormFieldContactInfoContactField["LAST_NAME"] = "LAST_NAME";
    /** Company name. */
    FormFieldContactInfoContactField["COMPANY"] = "COMPANY";
    /** Job position or title. */
    FormFieldContactInfoContactField["POSITION"] = "POSITION";
    /** Email address. */
    FormFieldContactInfoContactField["EMAIL"] = "EMAIL";
    /** Phone number. */
    FormFieldContactInfoContactField["PHONE"] = "PHONE";
    /** Physical address. */
    FormFieldContactInfoContactField["ADDRESS"] = "ADDRESS";
    /** Birth date. */
    FormFieldContactInfoContactField["BIRTHDATE"] = "BIRTHDATE";
    /** Custom field. */
    FormFieldContactInfoContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    /** Subscription status. */
    FormFieldContactInfoContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    /** VAT identification number. */
    FormFieldContactInfoContactField["VAT_ID"] = "VAT_ID";
})(FormFieldContactInfoContactField || (FormFieldContactInfoContactField = {}));
export var SpamFilterProtectionLevel;
(function (SpamFilterProtectionLevel) {
    /** Unknown spam filter protection level. */
    SpamFilterProtectionLevel["UNKNOWN"] = "UNKNOWN";
    /** No spam filtering. All submissions are accepted without screening. */
    SpamFilterProtectionLevel["NONE"] = "NONE";
    /** Basic spam filtering. Provides minimal protection against obvious spam and the form is open to a high risk of spam submissions. */
    SpamFilterProtectionLevel["BASIC"] = "BASIC";
    /** Advanced spam filtering. Provides comprehensive protection with intelligent screening and the form is open to a low risk of spam submissions. */
    SpamFilterProtectionLevel["ADVANCED"] = "ADVANCED";
})(SpamFilterProtectionLevel || (SpamFilterProtectionLevel = {}));
export var RequiredIndicator;
(function (RequiredIndicator) {
    /** Unknown required indicator type. */
    RequiredIndicator["UNKNOWN_INDICATOR"] = "UNKNOWN_INDICATOR";
    /** Display an asterisk (*) symbol to indicate required fields. */
    RequiredIndicator["ASTERISK"] = "ASTERISK";
    /** Display the text "Required" to indicate required fields. */
    RequiredIndicator["TEXT"] = "TEXT";
    /** No visual indicator is shown for required fields. */
    RequiredIndicator["NONE"] = "NONE";
})(RequiredIndicator || (RequiredIndicator = {}));
export var RequiredIndicatorPlacement;
(function (RequiredIndicatorPlacement) {
    /** Unknown required indicator placement. */
    RequiredIndicatorPlacement["UNKNOWN_PLACEMENT"] = "UNKNOWN_PLACEMENT";
    /** Place the required indicator after the field title. */
    RequiredIndicatorPlacement["AFTER_FIELD_TITLE"] = "AFTER_FIELD_TITLE";
    /** Place the required indicator before the field title. */
    RequiredIndicatorPlacement["BEFORE_FIELD_TITLE"] = "BEFORE_FIELD_TITLE";
})(RequiredIndicatorPlacement || (RequiredIndicatorPlacement = {}));
export var Target;
(function (Target) {
    /** Unknown target behavior. */
    Target["UNKNOWN_TARGET"] = "UNKNOWN_TARGET";
    /** Open the URL in the same browser tab, replacing the current page. */
    Target["SELF"] = "SELF";
    /** Open the URL in a new browser tab. */
    Target["BLANK"] = "BLANK";
})(Target || (Target = {}));
export var SubmitSuccessAction;
(function (SubmitSuccessAction) {
    /** Unknown submit success action. */
    SubmitSuccessAction["UNKNOWN_SUBMIT_SUCCESS_ACTION"] = "UNKNOWN_SUBMIT_SUCCESS_ACTION";
    /** No action is taken after form submission. */
    SubmitSuccessAction["NO_ACTION"] = "NO_ACTION";
    /** Display a thank you message after form submission. */
    SubmitSuccessAction["THANK_YOU_MESSAGE"] = "THANK_YOU_MESSAGE";
    /** Redirect the user to a specified URL after form submission. */
    SubmitSuccessAction["REDIRECT"] = "REDIRECT";
})(SubmitSuccessAction || (SubmitSuccessAction = {}));
/** Enum for different types of field properties that can be modified by rules. */
export var ChangeableProperty;
(function (ChangeableProperty) {
    /** Unknown property type. */
    ChangeableProperty["UNKNOWN_CHANGEABLE_PROPERTY"] = "UNKNOWN_CHANGEABLE_PROPERTY";
    /** Required property type. */
    ChangeableProperty["REQUIRED"] = "REQUIRED";
    /** Hidden property type. */
    ChangeableProperty["HIDDEN"] = "HIDDEN";
    /** Allowed values property type. */
    ChangeableProperty["ALLOWED_VALUES"] = "ALLOWED_VALUES";
})(ChangeableProperty || (ChangeableProperty = {}));
export var OverrideEntityTypeEnumOverrideEntityType;
(function (OverrideEntityTypeEnumOverrideEntityType) {
    /** Unknown override entity type. */
    OverrideEntityTypeEnumOverrideEntityType["UNKNOWN_OVERRIDE_ENTITY_TYPE"] = "UNKNOWN_OVERRIDE_ENTITY_TYPE";
    /** Override applies to a form field. */
    OverrideEntityTypeEnumOverrideEntityType["FIELD"] = "FIELD";
})(OverrideEntityTypeEnumOverrideEntityType || (OverrideEntityTypeEnumOverrideEntityType = {}));
export var Operator;
(function (Operator) {
    Operator["UNKNOWN_OPERATOR"] = "UNKNOWN_OPERATOR";
    /** Specified value equals the value in the target field. */
    Operator["EQUAL"] = "EQUAL";
    /** Specified value doesn't equal the value in the target field. */
    Operator["NOT_EQUAL"] = "NOT_EQUAL";
    /** Target field is empty or has no value. */
    Operator["EMPTY"] = "EMPTY";
    /** Target field isn't empty and has a value. */
    Operator["NOT_EMPTY"] = "NOT_EMPTY";
    /** String value in the target field contains the specified substring. */
    Operator["CONTAINS"] = "CONTAINS";
    /** String value in the target field doesn't contain the specified substring. */
    Operator["NOT_CONTAINS"] = "NOT_CONTAINS";
    /** Numeric value in the target field is less than the specified value. */
    Operator["LESS_THAN"] = "LESS_THAN";
    /** Numeric value in the target field is less than or equal to the specified value. */
    Operator["LESS_THAN_OR_EQUALS"] = "LESS_THAN_OR_EQUALS";
    /** Numeric value in the target field is greater than the specified value. */
    Operator["GREATER_THAN"] = "GREATER_THAN";
    /** Numeric value in the target field is greater than or equal to the specified value. */
    Operator["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
    /** Date value in the target field is before the specified date. */
    Operator["BEFORE"] = "BEFORE";
    /** Date value in the target field is before or equal to the specified date. */
    Operator["BEFORE_OR_EQUAL"] = "BEFORE_OR_EQUAL";
    /** Date value in the target field is after the specified date. */
    Operator["AFTER"] = "AFTER";
    /** Date value in the target field is after or equal to the specified date. */
    Operator["AFTER_OR_EQUAL"] = "AFTER_OR_EQUAL";
    /** Value in the target field falls within the specified range. */
    Operator["BETWEEN"] = "BETWEEN";
    /** Value in the target field matches any of the specified values. */
    Operator["ANY"] = "ANY";
    /** Array value in the target field exactly equals the specified array. */
    Operator["ARRAY_EQUAL"] = "ARRAY_EQUAL";
    /** Array value in the target field doesn't equal the specified array. */
    Operator["ARRAY_NOT_EQUAL"] = "ARRAY_NOT_EQUAL";
    /** Checkbox or boolean field value in the target field is checked. */
    Operator["CHECKED"] = "CHECKED";
    /** Checkbox or boolean field value in the target field isn't checked. */
    Operator["NOT_CHECKED"] = "NOT_CHECKED";
    /** Value in the target field is included in the specified list. */
    Operator["IN"] = "IN";
    /** Value in the target field isn't included in the specified list. */
    Operator["NOT_IN"] = "NOT_IN";
    /** Date value in the target field is older than the specified time period. */
    Operator["IS_DATE_OLDER_THAN"] = "IS_DATE_OLDER_THAN";
    /** Date value in the target field is older than or equal to the specified time period. */
    Operator["IS_DATE_OLDER_THAN_OR_EQUAL"] = "IS_DATE_OLDER_THAN_OR_EQUAL";
    /** Date value in the target field is newer than the specified time period. */
    Operator["IS_DATE_NEWER_THAN"] = "IS_DATE_NEWER_THAN";
    /** Date value in the target field is newer than or equal to the specified time period. */
    Operator["IS_DATE_NEWER_THAN_OR_EQUAL"] = "IS_DATE_NEWER_THAN_OR_EQUAL";
})(Operator || (Operator = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    /** Existing or new contact */
    IdentityType["CONTACT"] = "CONTACT";
    /** Member is logged in, matching logic skipped */
    IdentityType["MEMBER"] = "MEMBER";
    /** Matching contact is a member, Merge logic won't be applied */
    IdentityType["NOT_AUTHENTICATED_MEMBER"] = "NOT_AUTHENTICATED_MEMBER";
})(IdentityType || (IdentityType = {}));
export var ErrorType;
(function (ErrorType) {
    /** Error is unknown or not suitable for any of options bellow */
    ErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    /** Type of submitted value is incorrect */
    ErrorType["TYPE_ERROR"] = "TYPE_ERROR";
    /** Value is required to be provided */
    ErrorType["REQUIRED_VALUE_ERROR"] = "REQUIRED_VALUE_ERROR";
    /** Value contains additional properties not expected in schema */
    ErrorType["UNKNOWN_VALUE_ERROR"] = "UNKNOWN_VALUE_ERROR";
    /** Text value exceeds max length */
    ErrorType["MAX_LENGTH_ERROR"] = "MAX_LENGTH_ERROR";
    /** Text value not reaches min length */
    ErrorType["MIN_LENGTH_ERROR"] = "MIN_LENGTH_ERROR";
    /** Text value not applicable for expected pattern */
    ErrorType["PATTERN_ERROR"] = "PATTERN_ERROR";
    /** Text value not applicable for expected format */
    ErrorType["FORMAT_ERROR"] = "FORMAT_ERROR";
    /** Number value is too big */
    ErrorType["MAX_VALUE_ERROR"] = "MAX_VALUE_ERROR";
    /** Number value is too small */
    ErrorType["MIN_VALUE_ERROR"] = "MIN_VALUE_ERROR";
    /** Number value is not multiple of expected number */
    ErrorType["MULTIPLE_OF_VALUE_ERROR"] = "MULTIPLE_OF_VALUE_ERROR";
    /** Array value has too much items */
    ErrorType["MIN_ITEMS_ERROR"] = "MIN_ITEMS_ERROR";
    /** Array value has not enough items */
    ErrorType["MAX_ITEMS_ERROR"] = "MAX_ITEMS_ERROR";
    /** Value is not in list of allowed values */
    ErrorType["NOT_ALLOWED_VALUE_ERROR"] = "NOT_ALLOWED_VALUE_ERROR";
    /** Form fields are incompatible */
    ErrorType["FIELDS_COMPATIBILITY_ERROR"] = "FIELDS_COMPATIBILITY_ERROR";
    /** Submitted form is disabled */
    ErrorType["DISABLED_FORM_ERROR"] = "DISABLED_FORM_ERROR";
    /** Too much forms */
    ErrorType["FORMS_COUNT_RESTRICTIONS_ERROR"] = "FORMS_COUNT_RESTRICTIONS_ERROR";
    /** Too much fields on form */
    ErrorType["FIELDS_COUNT_RESTRICTIONS_ERROR"] = "FIELDS_COUNT_RESTRICTIONS_ERROR";
    /** Too much steps on forms */
    ErrorType["STEPS_COUNT_RESTRICTIONS_ERROR"] = "STEPS_COUNT_RESTRICTIONS_ERROR";
    /** Too much rules on forms */
    ErrorType["RULES_COUNT_RESTRICTIONS_ERROR"] = "RULES_COUNT_RESTRICTIONS_ERROR";
    /** File upload is not allowed */
    ErrorType["FILE_UPLOAD_RESTRICTIONS_ERROR"] = "FILE_UPLOAD_RESTRICTIONS_ERROR";
    /** Country code is not correct or missing from the phone number */
    ErrorType["INVALID_PHONE_COUNTRY_CODE_ERROR"] = "INVALID_PHONE_COUNTRY_CODE_ERROR";
    /** Invalid staff member ID on appointment */
    ErrorType["INVALID_STAFF_ID_ERROR"] = "INVALID_STAFF_ID_ERROR";
    /** Invalid business location ID on appointment */
    ErrorType["INVALID_LOCATION_ID_ERROR"] = "INVALID_LOCATION_ID_ERROR";
    /** Missing service option on service picker field */
    ErrorType["MISSING_SERVICE_OPTION_ERROR"] = "MISSING_SERVICE_OPTION_ERROR";
    /** Some of the service options on service picker field are deleted or unavailable */
    ErrorType["INVALID_SERVICE_OPTIONS_ERROR"] = "INVALID_SERVICE_OPTIONS_ERROR";
    /** All of the service options on service picker field are deleted or unavailable */
    ErrorType["NO_AVAILABLE_SERVICE_OPTIONS_ERROR"] = "NO_AVAILABLE_SERVICE_OPTIONS_ERROR";
    /** Text value does not match the exact required length */
    ErrorType["EXACT_CHARACTER_LENGTH_ERROR"] = "EXACT_CHARACTER_LENGTH_ERROR";
    /** Character count is not within the required range */
    ErrorType["CHARACTER_LENGTH_RANGE_ERROR"] = "CHARACTER_LENGTH_RANGE_ERROR";
    /** Number is not within the required range */
    ErrorType["VALUE_RANGE_ERROR"] = "VALUE_RANGE_ERROR";
    /** Field not have the exact number of options selected */
    ErrorType["EXACT_ITEMS_NUMBER_ERROR"] = "EXACT_ITEMS_NUMBER_ERROR";
    /** Number has incorrect number of decimal places */
    ErrorType["DECIMAL_POINT_ERROR"] = "DECIMAL_POINT_ERROR";
    /** Date value is incomplete or missing required parts */
    ErrorType["INCOMPLETE_DATE_ERROR"] = "INCOMPLETE_DATE_ERROR";
    /** Value does not match the required pattern format */
    ErrorType["INVALID_VALUE_FOR_PATTERN_ERROR"] = "INVALID_VALUE_FOR_PATTERN_ERROR";
})(ErrorType || (ErrorType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Mode;
(function (Mode) {
    /** Any of the search terms must be present */
    Mode["OR"] = "OR";
    /** All search terms must be present */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    Status["READY"] = "READY";
    Status["PENDING"] = "PENDING";
    Status["FAILED"] = "FAILED";
})(Status || (Status = {}));
export var SubmissionErrorType;
(function (SubmissionErrorType) {
    /** Error is unknown or unsuitable for any of the options below. */
    SubmissionErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    /** Type of submitted value is incorrect. */
    SubmissionErrorType["TYPE_ERROR"] = "TYPE_ERROR";
    /** Value is required to be provided. */
    SubmissionErrorType["REQUIRED_VALUE_ERROR"] = "REQUIRED_VALUE_ERROR";
    /** Value contains additional properties not expected in schema. */
    SubmissionErrorType["UNKNOWN_VALUE_ERROR"] = "UNKNOWN_VALUE_ERROR";
    /** Text value exceeds max length. */
    SubmissionErrorType["MAX_LENGTH_ERROR"] = "MAX_LENGTH_ERROR";
    /** Text value does not reach min length. */
    SubmissionErrorType["MIN_LENGTH_ERROR"] = "MIN_LENGTH_ERROR";
    /** Text value is not applicable for expected pattern. */
    SubmissionErrorType["PATTERN_ERROR"] = "PATTERN_ERROR";
    /** Text value is not applicable for expected format. */
    SubmissionErrorType["FORMAT_ERROR"] = "FORMAT_ERROR";
    /** Number value is too big. */
    SubmissionErrorType["MAX_VALUE_ERROR"] = "MAX_VALUE_ERROR";
    /** Number value is too small. */
    SubmissionErrorType["MIN_VALUE_ERROR"] = "MIN_VALUE_ERROR";
    /** Number value is not a multiple of expected number. */
    SubmissionErrorType["MULTIPLE_OF_VALUE_ERROR"] = "MULTIPLE_OF_VALUE_ERROR";
    /** Array value has too many items. */
    SubmissionErrorType["MIN_ITEMS_ERROR"] = "MIN_ITEMS_ERROR";
    /** Array value has not enough items. */
    SubmissionErrorType["MAX_ITEMS_ERROR"] = "MAX_ITEMS_ERROR";
    /** Value is not in the list of allowed values. */
    SubmissionErrorType["NOT_ALLOWED_VALUE_ERROR"] = "NOT_ALLOWED_VALUE_ERROR";
    /** Submitted form is disabled. */
    SubmissionErrorType["DISABLED_FORM_ERROR"] = "DISABLED_FORM_ERROR";
})(SubmissionErrorType || (SubmissionErrorType = {}));
//# sourceMappingURL=types.impl.js.map